














import {Component, Prop, Vue} from "vue-property-decorator";
import {MerchantCircle} from "@/entity/MerchantCircle";

@Component({
  components: {},
})

export default class Iframe extends Vue {
  @Prop({default: () => []})
  url !: string


  gerUrl() {
    this.url = this.$route.params.url
    console.log(this.url)
  }

  goback() {
    this.$router.go(-1)
  }

  mounted() {
    this.gerUrl()
  }
}
